import { HttpClient as Http, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from "../middleware/token-interceptor.service";
import { LogoutInterceptorService } from "../middleware/logout-interceptor.service";
import { Client } from "./API/client";
import { AuthGuardService } from "./auth-guard";
import { LocalStorage } from "./local-storage";
import { NotificationCountService } from "./notificationCountService";
import { SessionService } from "./session.service";
import { ModalAuthService } from "./ux/modal-auth.service";
import { DynamicFieldService } from "./ux/dynamic-field-service";
import { ModalPaymentService } from "./ux/modal-payment.service";
import { toastrService } from "./ux/toastr.service";
import { WalletService } from "./wallet.service";
import { DepositService } from "./deposit.service";
import { LoanService } from "./loan.service";
import { AccountService } from "./account.service";
import { LayoutService } from "./layout.service";
import { LanguageInterceptor } from "../middleware/language-interceptor.service";
import { LanguageService } from "./language.service";

export const HELIUS_POSTA_PROVIDERS: any[] = [
  {
    provide: Client,
    useFactory: Client._,
    deps: [Http]
  },
  {
    provide: SessionService,
    useFactory: SessionService._,
    deps: [LocalStorage]
  },
  {
    provide: toastrService,
    useFactory: toastrService._
  },
  {
    provide: ModalPaymentService,
    useFactory: ModalPaymentService._
  },
  {
    provide: ModalAuthService,
    useFactory: ModalAuthService._
  },
  {
    provide: LocalStorage,
    useFactory: LocalStorage._
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LogoutInterceptorService,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LanguageInterceptor,
    multi: true
  },
  {
    provide: WalletService,
    useFactory: WalletService._
  },
  AuthGuardService,
  DynamicFieldService,
  NotificationCountService,
  DepositService, 
  LoanService,
  AccountService,
  LayoutService,
  LanguageService
];
